import { Controller } from "@hotwired/stimulus"
import { subjectStore } from "../utils/subject_store"
import { toast } from "../utils/toast"

export default class extends Controller {
  static targets = ["form", "successMessage"]
  static outlets = ["photo-upload", "audio-recorder", "camera-capture"]
  static values = { projectId: String, redirectUrl: String }

  connect() {
    this.subjectStore = subjectStore

    // Check if we should show success message after redirect
    if (localStorage.getItem('showSubjectSavedMessage') === 'true') {
      localStorage.removeItem('showSubjectSavedMessage')
      // Show message after a brief delay to ensure DOM is ready
      setTimeout(() => this.showSuccessMessage(), 100)
    }
  }

  async submitForm(event) {
    event.preventDefault()

    let accumulatedPhotos = []

    // Get accumulated photos from photo upload controller (File objects)
    if (this.hasPhotoUploadOutlet) {
      accumulatedPhotos = accumulatedPhotos.concat(this.photoUploadOutlet.getAccumulatedPhotos())
    }

    let projectSpecificationIds = Array.from(this.formTarget.querySelectorAll('input[name="subject_form[project_specification_ids][]"]:checked')).map(input => input.value)

    // Get accumulated photos from camera capture controller (convert to File objects)
    if (this.hasCameraCaptureOutlet) {
      const cameraPhotos = this.cameraCaptureOutlet.getAccumulatedPhotos()
      const cameraPhotoFiles = cameraPhotos.map((photo, index) => {
        return new File([photo.blob], `photo_${photo.timestamp}_${index}.jpg`, {
          type: 'image/jpeg',
          lastModified: photo.timestamp
        })
      })
      accumulatedPhotos = accumulatedPhotos.concat(cameraPhotoFiles)
    }

    // Finalize audio recording (stops if active and returns the audio blob)
    let recordedAudio = null
    if (this.hasAudioRecorderOutlet) {
      recordedAudio = await this.audioRecorderOutlet.finalizeRecording()
      console.log('Got recorded audio:', !!recordedAudio, recordedAudio)
    }

    if (accumulatedPhotos.length === 0) {
      toast.warning('Please select at least one photo to upload.')
      return
    }

    // Show loading state
    const submitButton = this.formTarget.querySelector('button[type="submit"]')
    const originalText = submitButton.innerHTML
    submitButton.innerHTML = 'Saving locally...'
    submitButton.disabled = true

    try {
      // Store the subject data locally
      const subjectId = await this.subjectStore.save({
        photos: accumulatedPhotos,
        audio: recordedAudio,
        projectId: this.projectIdValue,
        projectSpecificationIds: projectSpecificationIds
      })

      // Automatically attempt to sync this subject once (non-blocking)
      this.subjectStore.syncToServer(subjectId).catch(syncError => {
        console.warn('Auto-sync failed for new subject:', syncError)
        // Continue - user can manually sync later
      })

      // Set flag to show success message after redirect
      localStorage.setItem('showSubjectSavedMessage', 'true')

      // Redirect immediately
      Turbo.visit(this.redirectUrlValue)

    } catch (error) {
      console.error('Error storing subject locally:', error)
      toast.error('Error saving data locally. Please try again!')

      // Restore button state
      submitButton.innerHTML = originalText
      submitButton.disabled = false
    }
  }

  showSuccessMessage() {
    if (this.hasSuccessMessageTarget) {
      this.successMessageTarget.classList.remove('hidden')

      // Auto-hide after 5 seconds
      setTimeout(() => {
        this.successMessageTarget.classList.add('hidden')
      }, 5000)
    }
  }

}